import { inject, Injectable } from '@angular/core';

import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AgentPreviewAuthService {
  authService = inject(AuthService);

  initFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source');
    const token = params.get('preview_token');

    if (utmSource !== 'agent_preview' || !token) {
      return;
    }

    this.authService.user = { token };

    params.delete('preview_token');

    const cleanSearch = params.toString();

    const cleanUrl = cleanSearch
      ? `${window.location.pathname}?${cleanSearch}`
      : window.location.pathname;

    window.history.replaceState({}, '', cleanUrl);
  }
}
